/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Psm_AutoInputs */

const en_ocr_psm_auto = /** @type {(inputs: Ocr_Psm_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic (Full Page)`)
};

const fr_ocr_psm_auto = /** @type {(inputs: Ocr_Psm_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatique (Page complète)`)
};

const de_ocr_psm_auto = /** @type {(inputs: Ocr_Psm_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch (Vollbild)`)
};

const it_ocr_psm_auto = /** @type {(inputs: Ocr_Psm_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatico (Pagina intera)`)
};

const ru_ocr_psm_auto = /** @type {(inputs: Ocr_Psm_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматический (полная страница)`)
};

const es_ocr_psm_auto = /** @type {(inputs: Ocr_Psm_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático (Página completa)`)
};

const zh_cn2_ocr_psm_auto = /** @type {(inputs: Ocr_Psm_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动（整页）`)
};

const ja_ocr_psm_auto = /** @type {(inputs: Ocr_Psm_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動（全ページ）`)
};

const hi_ocr_psm_auto = /** @type {(inputs: Ocr_Psm_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित (पूर्ण पृष्ठ)`)
};

const pt_pt2_ocr_psm_auto = /** @type {(inputs: Ocr_Psm_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático (Página inteira)`)
};

/**
* | output |
* | --- |
* | "Automatic (Full Page)" |
*
* @param {Ocr_Psm_AutoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_psm_auto = /** @type {((inputs?: Ocr_Psm_AutoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Psm_AutoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_psm_auto(inputs)
	if (locale === "de") return de_ocr_psm_auto(inputs)
	if (locale === "it") return it_ocr_psm_auto(inputs)
	if (locale === "ru") return ru_ocr_psm_auto(inputs)
	if (locale === "es") return es_ocr_psm_auto(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_psm_auto(inputs)
	if (locale === "ja") return ja_ocr_psm_auto(inputs)
	if (locale === "hi") return hi_ocr_psm_auto(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_psm_auto(inputs)
	return en_ocr_psm_auto(inputs)
});